import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import { getItems } from "src/apis/itemSlice";

export default function ItemList() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { items } = useSelector((state) => state.itemData);
  const { loggedIn } = useSelector((state) => state.authData);

  useEffect(() => {
    if (loggedIn?._id) {
      dispatch(getItems({ uId: loggedIn?._id }));
    }
  }, [loggedIn]);

  return (
    <div className="p-3">
      <Button
        icon={"pi pi-home"}
        className="h-[3rem] m-2"
        onClick={() => navigate("/")}
      />
      {items.map((item, index) => {
        return (
          <div
            key={index}
            className="border-2 border-gray-300 p-3 m-2 rounded-md shadow-md"
          >
            <h1 className="text-lg font-bold">{item.item_name}</h1>
            <p>Rate = {item.item_rate}</p>
          </div>
        );
      })}
    </div>
  );
}
